
import { mixins, Options } from "vue-class-component";
import GuestLayout from "@/layout/GuestLayout.vue";
import Validation from "@/components/validation/Validation.vue";
import { required } from "@vuelidate/validators";
import { namespace } from "vuex-class";
import { GuestFormMixin } from "@/mixins/form/GuestFormMixin";
import { twoFactorAuthCheck } from "@/store/auth/actions";

const AuthModule = namespace("auth");

@Options({
  components: { Validation, GuestLayout },
  validations: {
    authCode: { required },
  },
})
export default class TwoFactorAuth extends mixins(GuestFormMixin) {
  private authCode?: string | null = null;
  private qrUrl = `${process.env.VUE_APP_BACKEND_BASE_URL}api/two_factor`;

  @AuthModule.Action("twoFactorAuthCheck")
  private twoFactorAuthCheck: any;

  @AuthModule.Getter("getIsLoading")
  private isLoading: any;

  @AuthModule.Getter("getError")
  private error: any;

  private onSubmit(e: any): void {
    if (e) {
      (e as Event).preventDefault();
    }
    if (this.isInvalidate()) {
      return;
    }
    this.twoFactorAuthCheck(this.authCode);
  }
}
